/**
 * @desc 邮件回复
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(ticketId: string | number, options?: any) {
  return updateResponse(
    http(URL + `/crm/ticket/${ticketId}`, {
      method: "GET",

      ...options,
    }),
  );
}
